import { createApp } from 'vue';

import BoardPriceCalculator from 'components/BoardPriceCalculator.vue';
import { i18n } from 'locales';

export default function initializeBoardPriceCalculator() {
  const mountElement = '#vue-board-price-calculator';
  const calculator = document.querySelector(mountElement);
  if (calculator === null) {
    return;
  }

  const app = createApp();
  app.component(BoardPriceCalculator.name, BoardPriceCalculator);
  app.use(i18n);

  app.mount(mountElement);
}
